<ng-container *transloco="let t; read: 'changeHistory'">
<div class="change-history-container">
  <button
    class="info-button"
    (click)="toggle()"
    (clickOutside)="close()"
    aria-label="Show change history">
    i
  </button>

  <div class="popup" *ngIf="isOpen">
    <div class="popup-content">
      <div class="popup-row">
        <span class="label"><strong>{{ t('created') }}</strong></span>
        <p class="value">{{ createdBy | user | async }}, {{ createdOn | date:'dd.MM.yyyy HH:mm' }}</p>
      </div>

      <hr class="divider" />

      <div class="popup-row">
        <span class="label"><strong>{{ t('lastModified') }}</strong></span>
        <p class="value">{{ lastModifiedBy | user | async }}, {{ lastModifiedOn | date:'dd.MM.yyyy HH:mm' }}</p>
      </div>
    </div>
    <a (click)="close()" class="popup-close">x</a>
  </div>
</div>
</ng-container>
